
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","stroke":"#000","opacity":".4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.666 15s.833 0 1.667 1.667c0 0 2.647-4.167 5-5","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.833 18.333H5.492c-1.288 0-2.312-.626-3.232-1.503-1.883-1.793 1.208-3.227 2.387-3.929a8.89 8.89 0 018.686-.198","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.75 5.417a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z","stroke-width":"1.5"}})])
          )
        }
      }
    